import { motion } from "framer-motion";

const CountryIllustration = () => {
  return (
    <div className="w-full h-full relative">
      <div className="absolute inset-0 bg-gradient-to-br from-red-50 to-rose-100"></div>
      <motion.svg
        width="400"
        height="400"
        viewBox="0 0 500 500"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute inset-0 m-auto"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        {/* Browser window */}
        <motion.path
          d="M100 150C100 144.477 104.477 140 110 140H390C395.523 140 400 144.477 400 150V350C400 355.523 395.523 360 390 360H110C104.477 360 100 355.523 100 350V150Z"
          fill="#ECFDF5"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
        />
        <motion.path
          d="M110 140H390C395.523 140 400 144.477 400 150V350C400 355.523 395.523 360 390 360H110C104.477 360 100 355.523 100 350V150C100 144.477 104.477 140 110 140Z"
          stroke="#C71F2C"
          strokeWidth="8"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        />
        <motion.path
          d="M100 180H400"
          stroke="#C71F2C"
          strokeWidth="8"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 0.6, delay: 0.8 }}
        />

        {/* Browser buttons */}
        <motion.circle
          cx="130"
          cy="160"
          r="10"
          fill="#EF4444"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.3, delay: 1.0 }}
        />
        <motion.circle
          cx="160"
          cy="160"
          r="10"
          fill="#F59E0B"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.3, delay: 1.1 }}
        />
        <motion.circle
          cx="190"
          cy="160"
          r="10"
          fill="#10B981"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.3, delay: 1.2 }}
        />

        {/* Continents */}
        <motion.g>
          {/* North America */}
          <motion.path
            d="M150 220C150 220 180 210 210 230C240 250 230 290 250 300"
            stroke="#C71F2C"
            strokeWidth="4"
            strokeLinecap="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 0.8, delay: 1.4 }}
          />

          {/* South America */}
          <motion.path
            d="M210 320C210 320 230 300 220 280C210 260 230 260 240 250"
            stroke="#C71F2C"
            strokeWidth="4"
            strokeLinecap="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 0.8, delay: 1.6 }}
          />

          {/* Europe */}
          <motion.path
            d="M270 220C270 220 290 210 310 220C330 230 320 250 340 250"
            stroke="#C71F2C"
            strokeWidth="4"
            strokeLinecap="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 0.8, delay: 1.8 }}
          />

          {/* Africa */}
          <motion.path
            d="M290 260C290 260 300 280 290 300C280 320 300 330 310 320"
            stroke="#C71F2C"
            strokeWidth="4"
            strokeLinecap="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 0.8, delay: 2.0 }}
          />

          {/* Asia */}
          <motion.path
            d="M340 230C340 230 350 210 370 220C390 230 370 260 380 280"
            stroke="#C71F2C"
            strokeWidth="4"
            strokeLinecap="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 0.8, delay: 2.2 }}
          />

          {/* Australia */}
          <motion.path
            d="M350 320C350 320 370 330 380 310C390 290 360 300 350 290"
            stroke="#C71F2C"
            strokeWidth="4"
            strokeLinecap="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 0.8, delay: 2.4 }}
          />
        </motion.g>
      </motion.svg>
    </div>
  );
};

export default CountryIllustration;
